var exports = {
  "k": "x7be19a29--beb141--container",
};

module.exports = exports;
